import { Component, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef, ModalComponent, overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Subject } from 'rxjs';
import 'rxjs/Rx';
import { User } from '../../models/user/user';
import { resetpasswordmodel } from '../../models/user/user.resetPassword.model';
import { enumEventype, UserProfileTMNIovation } from '../../models/user/user.tm.profile.model';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { ErrorPopupComponent } from '../../sharedcomponents/_directive/error-popup/error-popup.component';
import { AuthService } from '../../_services/userservice/auth.service';
import { usercommonattribute } from '../../_services/userservice/user.common.service';
import { forgotPasswordService } from '../../_services/userservice/user.forgotpassword.service'; //For accessing user mail
import { resetPasswordService } from '../../_services/userservice/user.resetchangepassword.service';
import { UserStateService } from '../../_services/userservice/userstateservice';

export class resetModalContext extends BSModalContext {}

declare var Crypto: any;
declare var CryptoService: any;
@Component({
  moduleId: module.id,
  providers: [AuthService, resetPasswordService, forgotPasswordService, AlertService],
  selector: 'app-reset-password',
  templateUrl: './reset-password.EditProfile.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordEditProfileComponent implements ModalComponent<resetModalContext> {
  context: resetModalContext;
  userProfileTMNIovation: UserProfileTMNIovation;
  public isDOBflag: boolean;
  public isTransflag: boolean;
  CryptoObj: any;
  cryptoService: any;
  appSettings: any;
  model: resetpasswordmodel;
  saveModel: resetpasswordmodel;
  loading = false;
  userData: User;

  private _newPassword: string = '';

  get NewPassword(): string {
    return this._newPassword;
  }

  set NewPassword(value: string) {
    this._newPassword = value;
  }

  private subProfile = new Subject<boolean>();
  @Output()
  subProfileObservable = this.subProfile.asObservable();
  constructor(
    public dialog: DialogRef<resetModalContext>,
    private router: Router,
    private rstPassword: resetPasswordService,
    public modal: Modal,
    private userCommon: usercommonattribute,
    public utilserv: utilityService,
    private translate: TranslateService,
    private auth: AuthService,
    private userStateService: UserStateService,
    private alertService: AlertService
  ) {
    this.context = dialog.context;

    this.CryptoObj = Crypto;
    this.cryptoService = new CryptoService();

    const userStateServiceSub = this.userStateService.getcurrentUserDetailData().subscribe(data => {
      this.userData = new User();
      this.userData = data;
      if (userStateServiceSub != undefined) {
        userStateServiceSub.unsubscribe();
      }
    });
  }

  ngOnInit() {
    this.appSettings = AppSettings;
    this.model = new resetpasswordmodel();
  }

  resetPasswordClick() {

    this.model.NewPassWord = this._newPassword;

    this.saveModel = new resetpasswordmodel();
    this.saveModel.KeyUID = this.userCommon.KeyUID;
    this.saveModel.NewPassWord = this.cryptoService.RSAEncrypt(this.model.NewPassWord, sessionStorage.publicKeyRSA);
    this.saveModel.OldPassWord = this.cryptoService.RSAEncrypt(this.model.OldPassWord, sessionStorage.publicKeyRSA);

    this.utilserv.busy = this.rstPassword.resetPasswordEditProfile(this.saveModel).subscribe(
      data => {
        const resJSON = data;

        if (resJSON.Envelope.Body.BaseResponse.StatusCode == 20001) {
          return false;
        } else if (resJSON.Envelope.Body.BaseResponse.StatusCode == -10000) {
          this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
          return;
        } else if (resJSON.Envelope.Body.BaseResponse.StatusCode == enumStatusCodeList.SUCCESS) {
          //   this.alertService.success(resJSON.Envelope.Body.BaseResponse.StatusMessage);
          let modalData: any = {};
          const _self = this;
          modalData.Title = this.translate.instant('AddToCartSuccess_title').toString();
          modalData.Message = this.translate.instant('Message_lblPasswordUpdatedSuccessfully');
          return this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
            obj.onDestroy.subscribe(data => {
              console.log('Observer got a next value: ' + data);
              _self.closePopup();
              _self.router.navigate(['/splashscreen']);
            });
          });
        } else {
          this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant(resJSON.Envelope.Body.BaseResponse.StatusMessage));
        }
      },
      err => console.log(err),
      () => console.log('Completed')
    );

    this.loading = true;
  }
  closePopup() {
    this.dialog.close();
  }
  errorPopup(title, message) {
    const modalData: any = {};
    modalData.Title = title;
    modalData.Message = message;
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }

  LengthPolicy(): boolean {
    return this._newPassword.length >= 8 && this._newPassword.length <= 15;
  }

  OneUppercaseLetterPolicy(): boolean {
    return /[A-Z]+?/.test(this._newPassword);
  }

  OneLowercaseLetterPolicy(): boolean {
    return /[a-z]+?/.test(this._newPassword);
  }

  OneDigitPolicy(): boolean {
    return /[0-9]+?/.test(this._newPassword);
  }

  OneSpecialCharPolicy(): boolean {
    return (new RegExp(this.appSettings.passwordSpecialCharPattern)).test(this._newPassword);
  }
}



// WEBPACK FOOTER //
// ./src/app/user/reset-password/reset-password.EditProfile.component.ts